import { render, staticRenderFns } from "./JobMatch.vue?vue&type=template&id=56ae2dca&scoped=true"
import script from "./JobMatch.vue?vue&type=script&lang=js"
export * from "./JobMatch.vue?vue&type=script&lang=js"
import style0 from "./JobMatch.vue?vue&type=style&index=0&id=56ae2dca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ae2dca",
  null
  
)

export default component.exports